import { transformThemeToDefaultAssets } from 'config/theme-transformation-utils';
import type { Core } from 'core/config/types';

/**
 * Replaces board asset with fallback version
 * @param context
 */
export function setBoardFallback(context: Core.Context) {
  if (!context.options.themeAssets) {
    return;
  }

  context.api.setOptions({
    themeAssets: transformThemeToDefaultAssets(context.options.themeAssets),
  });
}
